// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiNewPlan {
    static getAttributeTypeMap() {
        return PharmacyBiNewPlan.attributeTypeMap;
    }
}
PharmacyBiNewPlan.discriminator = undefined;
PharmacyBiNewPlan.additionalProperties = false;
PharmacyBiNewPlan.attributeTypeMap = [
    {
        "name": "available",
        "baseName": "available",
        "type": "string"
    },
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "string"
    },
    {
        "name": "subscriberId",
        "baseName": "subscriberId",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiNewPlan.js.map